<div id="content" class="allcp-form" ng-controller="OfferController" ng-init="new()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="row mt20">
		<div class="panel">
			<div class="panel-heading">
				<span class="panel-title"> Add New Offer</span>
				<hr>
			</div>
			<div class="panel-body pn">
				<form ng-submit="save()" class="form-horizontal allcp-form">
					<div class="col-md-7">
						<div class="form-group">
							<label class="col-md-3 control-label">
								Offer Count *
							</label>
							<div class="col-md-9">
								<label for="name21" class="field">
									<input type="text" ng-model="offer.count" class="gui-input br-light light" placeholder="Offer Count" required>
								</label>
							</div>
						</div>
						<div class="form-group">
							<label class="col-md-3 control-label">
								Date *
							</label>
							<div class="col-md-9">
								<input id="date" type="text" class="gui-input br-light light" required ng-model="offer.date" placeholder="Date">
							</div>
						</div>
						<div class="form-group">
							<label class="col-md-3 control-label">
								Station *
							</label>
							<div class="col-md-9">
								<label for="field_type" class="field select">
									<select id="type" name="type" ng-model="offer.station_id" required>
										<option value="">Select Station</option>
										<option value="{{ item.id }}" ng-repeat="item in stations">{{ item.code }}</option>
									</select>
									<i class="arrow"></i>
								</label>
							</div>
						</div>
						<div class="form-group">
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Save</a>
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
					<div class="row">
						<div class="col-md-4" 
							ng-repeat="i in getNumber(offer.count) track by $index">
							<div class="offer-box">
								<div class="form-group">
									<label class="col-md-3 control-label">
										Start-End Time *
									</label>
									<div class="col-md-9">
										<div class="row">
											<div class="col-md-6 pl10">
												<input id="start{{ $index }}" type="text" class="gui-input br-light light" required ng-model="offer.offers[$index].start_time">
											</div>
											<div class="col-md-6 pl10">
												<input id="end{{ $index }}" type="text" class="gui-input br-light light" required ng-model="offer.offers[$index].end_time">
											</div>
										</div>
									</div>
								</div>

								<div class="form-group">
									<label class="col-md-3 control-label">
										Price *
									</label>
									<div class="col-md-9">
										<label for="label" class="field">
											<input type="text" ng-model="offer.offers[$index].price" class="gui-input br-light light" placeholder="Offer Price" required>
										</label>
									</div>
								</div>
								<div class="form-group">
									<label class="col-md-3 control-label">
										Wehicle *
									</label>
									<div class="col-md-9">
										<label for="field_type" class="field select">
											<select id="type" name="type" ng-model="offer.offers[$index].wehicle" required>
												<option value="">Select Wehicle</option>
												<option value="Small">Small</option>
												<option value="Medium">Medium</option>
												<option value="Large">Large</option>
											</select>
											<i class="arrow"></i>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
